import LRU from 'lru-cache';

const skipFailedAssignedSessionsCache = new LRU<string, boolean>({
    max: 500,
    maxAge: process.env.IS_BEHAVIOUR_TEST === 'true' ? 1 : 2 * 60 * 1000,
});

export default skipFailedAssignedSessionsCache;
